import { Modal, Button, Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useState } from "react";

interface RejectInvoiceModalProps {
	open: boolean;
	invoiceNumber?: string;
	onCancel: () => void;
	onSubmit: (comment: string) => Promise<void>;
}

const DisacrdInvoiceModal: React.FC<RejectInvoiceModalProps> = ({ open, invoiceNumber, onCancel, onSubmit }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const handleFinish = async (values: { comment?: string }) => {
		try {
			setLoading(true);
			await onSubmit(values.comment ?? "Admin discarded the invoice");
			form.resetFields();
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			open={open}
			title={`Discard Invoice ${invoiceNumber ?? ""}`}
			onCancel={() => {
				form.resetFields();
				onCancel();
			}}
			footer={null} // ⬅️ IMPORTANT
		>
			<Form form={form} layout="vertical" onFinish={handleFinish}>
                <p className="my-3"> Are you sure you want to discard this invoice {invoiceNumber ?? ""}. </p>
				{/* <Form.Item
					label="Discard Reason"
					name="comment"
					rules={[
						{ required: true, message: "Please enter discard reason" },
						{ whitespace: true, message: "Comment cannot be empty" }
					]}
				>
					<TextArea rows={4} placeholder="Enter discard reason" maxLength={500} showCount />
				</Form.Item> */}

				<div style={{ textAlign: "right" }}>
					<Button onClick={onCancel} style={{ marginRight: 8 }}>
						Cancel
					</Button>
					<Button type="primary" danger htmlType="submit" loading={loading}>
						Discard
					</Button>
				</div>
			</Form>
		</Modal>
	);
};

export default DisacrdInvoiceModal;
